import React, { useState } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import moment from "moment";
import axios from "axios";
import crossImage from "../../images/singleinvoice/cross-red.svg";
import Delete from "../../images/icons/delete.svg";
import { ButtonSkeleton } from "./CalendarComponents/SkeletonLoader.jsx";

const DeleteHolidayModal = ({
    deleteHolidayModalOpen,
    setDeleteHolidayModalOpen,
    selectedEvents,
    selectedHolidayForDelete,
    setSelectedHolidayForDelete,
    refetchHolidays,
    setModalIsOpen,
    token,
}) => {
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [deleteScope, setDeleteScope] = useState('thisEvent');
    const isRecurring = selectedHolidayForDelete?.repeatType && selectedHolidayForDelete.repeatType !== "does_not_repeat" ? true : false;

    const handleDeleteHoliday = async () => {
        try {
            setIsSubmitLoading(true);
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    deleteScope,
                    instanceDate: isRecurring && deleteScope === "thisEvent"
                        ? moment(selectedHolidayForDelete.start).format('YYYYMMDDTHHmmss[Z]')
                        : null,
                },
            };
            await axios.delete(`/api/holidays/delete/${selectedHolidayForDelete.id}`, config);
            toast.success(`Holiday deleted successfully (${deleteScope === 'thisEvent' ? 'this event only' : 'this and following events'})`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            refetchHolidays();
            setDeleteHolidayModalOpen(false);
            setModalIsOpen(false);
            setSelectedHolidayForDelete(null);
            setDeleteScope('thisEvent');
        } catch (error) {
            console.error("Error deleting holiday:", error);
            toast.error(error.response?.data?.message || "Something went wrong", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelDeleteHoliday = () => {
        setDeleteHolidayModalOpen(false);
        setSelectedHolidayForDelete(null);
        setDeleteScope('thisEvent');
        document.body.classList.remove("ReactModal__Body--open");
    };

    return (
        <Modal
            className="center-modal"
            isOpen={deleteHolidayModalOpen}
            onRequestClose={!isSubmitLoading ? handleCancelDeleteHoliday : undefined}
            contentLabel="Confirm Delete Holiday"
            style={{
                content: {
                    width: "300px",
                    height: "200px",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    borderRadius: "12px",
                    background: "#fff",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    border: "none",
                },
                overlay: {
                    backgroundColor: "rgba(0,0,0,0.5)",
                },
            }}
        >
            <div className="delete-modal-content">
                <div className="modal-close-invite outter-modal-main">
                    <a onClick={handleCancelDeleteHoliday} disabled={isSubmitLoading}>
                        <img src={crossImage} alt="Close Icon" />
                    </a>
                </div>
                <h2>{isRecurring ? "Delete recurring holiday?" : "Delete holiday?"}</h2>
                {isRecurring ? (
                    <div className="delete-options-recuring">
                        <label className="radio-options">
                            <input
                                type="radio"
                                value="thisEvent"
                                checked={deleteScope === 'thisEvent'}
                                onChange={() => setDeleteScope('thisEvent')}
                                disabled={isSubmitLoading}
                            />
                            <span>This event only</span>
                        </label>
                        <label className="radio-options">
                            <input
                                type="radio"
                                value="thisAndFollowing"
                                checked={deleteScope === 'thisAndFollowing'}
                                onChange={() => setDeleteScope('thisAndFollowing')}
                                disabled={isSubmitLoading}
                            />
                            <span>This and following events</span>
                        </label>
                    </div>
                ) : (
                    <p>Are you sure you want to delete this event?</p>
                )}
                <div className="delete-modal-buttons">
                    <button
                        onClick={handleDeleteHoliday}
                        disabled={isSubmitLoading || (isRecurring && !deleteScope)}
                        className="modal-btn modal-btn-calendar delete"
                    >
                        {isSubmitLoading ? (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                                <ButtonSkeleton width="80px" height="18px" />
                            </div>
                        ) : (
                            <>
                                Delete
                                <img src={Delete} alt="Delete" />
                            </>
                        )}
                    </button>
                    <button
                        onClick={handleCancelDeleteHoliday}
                        disabled={isSubmitLoading}
                        className="modal-btn modal-btn-calendar cancel"
                    >
                        {isSubmitLoading ? (
                            <ButtonSkeleton width="60px" height="18px" />
                        ) : (
                            "Cancel"
                        )}
                    </button>
                </div>
            </div>
        </Modal >
    );
};

export default DeleteHolidayModal;